<div class="row page-title">
  <span>{{ localizationConstants.SERVICE_REQUEST_PAGE_TITLE | translate }}</span>
</div>

<div
  class="row"
  *ngIf="!basket.tools?.length">
  <div class="col center c-submit">
    <div class="c-submit__title">
      {{ "servicerequest.notoolsfound" | translate }}
    </div>
    <div class="c-submit__item">
      {{ "servicerequest.goto" | translate }}
      <a (click)="onToolsOnsiteClick()">{{
        localizationConstants.TOOLS_ON_SITE_PAGE_TITLE | translate
      }}</a>
    </div>
  </div>
</div>
<mat-sidenav-container
  class="service-request-sidenav__container sidenav__container-full-page-height">
  <app-service-request-service-form
    (formChanged)="onServiceFormChanged()"
    (startRequestClick)="onStartRequestClick()"
    (removeAll)="removeAll()"
    [isRaResultReceived]="isRaResultReceived"
    [equipment]="basket.tools"
    [options]="options"
    [showValidationErrors]="isStartRequestButtonPressed"
    [ra]="ra()"></app-service-request-service-form>

  <mat-sidenav
    #sideServiceRequestStepper
    position="start"
    class="service-request-sidenav__drawer"
    [fixedInViewport]="true">
    <div class="full-screen-stepper">
      <div style="width: 100%">
        <div class="row service-request-stepper__header">
          <a routerLink="{{ routeNameConstants.ROOT }}"
            ><img
              class="c-logo"
              [src]="brandingService.getBrandLogo()"
              alt="Where Is My Tool"
          /></a>
        </div>
      </div>

      <div class="row stepper-wrapper">
        <mat-stepper
          #stepper
          [linear]="true"
          class="step-content-wrapper">
          <!-- TODO: make stepper vertical on mobile -->
          <ng-template matStepperIcon="edit">
            <mat-icon svgIcon="edit"></mat-icon>
          </ng-template>
          <ng-template matStepperIcon="done">
            <mat-icon svgIcon="checkmark"></mat-icon>
          </ng-template>

          <!-- SHIPPING STEP -->

          <mat-step
            [stepControl]="step1form.form"
            [editable]="!isRaResultReceived">
            <ng-template matStepLabel>{{
              localizationConstants.SERVICE_REQUEST_STEP_SHIPPING | translate
            }}</ng-template>

            <div class="stepper-content">
              <div class="stepper-content-main">
                <form
                  #step1form="ngForm"
                  [id]="formsIds[serviceRequestStepType.Shipping]">
                  <app-service-request-step-one
                    *ngIf="isStartRequestButtonPressed"
                    [currentShipFrom]="currentShipFrom"
                    (currentShipFromChange)="currentShipFrom = $event"
                    [isRaResultReceived]="isRaResultReceived"
                    [showValidationErrors]="isShippingStepContinuePressed"
                    [isShipmentRequested]="ra().isShipmentRequested"
                    (isShipmentRequestedChange)="ra().isShipmentRequested = $event"
                    [customerSettings]="customerSettings"
                    [vendorList]="vendorList()"
                    [vendorName]="ra().vendor"
                    (vendorNameChange)="setVendor($event)"></app-service-request-step-one>
                </form>
              </div>
              <div class="stepper-content-side">
                <app-service-request-stepper-control
                  [disableContinueBtn]="disableContinueBtn()"
                  [currentStep]="serviceRequestStepType.Shipping"
                  [equipmentList]="basket.tools"
                  (continue)="continueStepper($event)"
                  (stepperClose)="closeStepper()"
                  class="fixed-stepper-control">
                </app-service-request-stepper-control>
              </div>
            </div>
          </mat-step>

          <!-- DETAILS STEP -->

          <mat-step
            [stepControl]="step2form.form"
            [editable]="!isRaResultReceived">
            <ng-template matStepLabel>{{
              localizationConstants.SERVICE_REQUEST_STEP_DETAILS | translate
            }}</ng-template>
            <div class="stepper-content">
              <div class="stepper-content-main">
                <form
                  #step2form="ngForm"
                  [id]="formsIds[serviceRequestStepType.Details]">
                  <app-service-request-step-two
                    *ngIf="step2form"
                    [step2form]="step2form.form"
                    [isRaResultReceived]="isRaResultReceived"
                    [customerSettings]="customerSettings"
                    [showValidationErrors]="isDetailStepContinuePressed"
                    [isShipmentRequested]="ra().isShipmentRequested"
                    [ra]="ra()"
                    (attachDocument)="attachDocument($event)"
                    [poRequired]="poRequired"></app-service-request-step-two>
                </form>
              </div>
              <div class="stepper-content-side">
                <app-service-request-stepper-control
                  [disableContinueBtn]="disableContinueBtn()"
                  [currentStep]="serviceRequestStepType.Details"
                  [equipmentList]="basket.tools"
                  (continue)="continueStepper($event)"
                  (stepperClose)="closeStepper()"
                  class="fixed-stepper-control">
                </app-service-request-stepper-control>
              </div>
            </div>
          </mat-step>

          <!-- REVIEW STEP -->

          <mat-step
            #reviewStep
            [completed]="false"
            [editable]="false">
            <ng-template matStepLabel>{{
              localizationConstants.SERVICE_REQUEST_STEP_REVIEW | translate
            }}</ng-template>
            <div class="stepper-content">
              <final-step-main-content
                *ngIf="isDetailStepContinuePressed"
                [ra]="ra()"
                [vendorNameToShow]="selectedVendorName()"
                [currentShipFrom]="currentShipFrom"
                [companyName]="companyService.selectedCompany.fullName"
                [packages]="step2form.value.shippingParcels"
                [customerSettings]="customerSettings"
                [shipmentPickupDetails]="shipmentPickupDetails"
                [showShipmentDetails]="true"
                class="stepper-content-main">
              </final-step-main-content>
              <div class="stepper-content-side">
                <app-service-request-stepper-control
                  [disableContinueBtn]="disableContinueBtn()"
                  [currentStep]="serviceRequestStepType.Review"
                  [equipmentList]="basket.tools"
                  (continue)="continueStepper($event)"
                  (stepperClose)="closeStepper()"
                  class="fixed-stepper-control">
                </app-service-request-stepper-control>
              </div>
            </div>
          </mat-step>

          <!-- CONFIRMATION STEP -->

          <mat-step [editable]="false">
            <ng-template matStepLabel>{{
              localizationConstants.SERVICE_REQUEST_STEP_CONFIRMATION | translate
            }}</ng-template>
            <div class="stepper-header-wrapper u-flex-column u-mt--large u-mb--large">
              <div class="stepper-header-image u-mt--large u-mb--medium">
                <img
                  [src]="brandingService.getBrandBanner()"
                  alt="confirmation" />
                <div class="stepper-header-image-message">
                  {{ localizationConstants.SERVICE_REQUEST_STEP_CONFIRMATION_MESSAGE | translate }}
                </div>
              </div>
              <div class="u-flex-column gap-lg">
                <div class="u-mw--600 u-p-x-medium">
                  {{
                    localizationConstants.SERVICE_REQUEST_STEP_CONFIRMATION_MESSAGE_2 | translate
                  }}
                </div>
                <div class="u-p-x-medium">
                  <button
                    (click)="downloadFile()"
                    class="button-block button button-secondary flex middle center u-mw--350">
                    <mat-icon svgIcon="download"></mat-icon>
                    <span class="button__label button__mobile-label">{{
                      localizationConstants.BUTTON_SERVICE_REQUEST_DOWNLOAD_FILE | translate
                    }}</span>
                  </button>
                </div>
                <div *ngIf="shipmentCreatedResult?.isShipmentCreated">
                  <div class="u-p-x-medium">
                    <a
                      [href]="shipmentCreatedResult.file.publicUrl"
                      class="button-block button button-secondary flex middle center u-mw--300">
                      <mat-icon svgIcon="barcode"></mat-icon>
                      <span class="button__label button__mobile-label">{{
                        localizationConstants.SERVICE_REQUEST_BUTTON_PRINT_LABEL | translate
                      }}</span>
                    </a>
                  </div>
                  <div class="u-p-x-medium u-mw--600">
                    <label class="c-label flex u-align-center">
                      <mat-icon
                        svgIcon="warning"
                        class="icon-size-xxs"></mat-icon>
                      <span>{{
                        localizationConstants.SERVICE_REQUEST_SHIPPING_LABEL_INSTRUCTIONS
                          | translate
                      }}</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div class="stepper-content">
              <final-step-main-content
                *ngIf="isRaResultReceived"
                [ra]="ra()"
                [vendorNameToShow]="selectedVendorName()"
                [currentShipFrom]="currentShipFrom"
                [companyName]="companyService.selectedCompany.fullName"
                [packages]="step2form.value.shippingParcels"
                [customerSettings]="customerSettings"
                [shipmentPickupDetails]="shipmentPickupDetails"
                [showShipmentDetails]="shipmentCreatedResult?.isShipmentCreated"
                class="stepper-content-main">
              </final-step-main-content>
              <div class="stepper-content-side">
                <app-service-request-stepper-control
                  [disableContinueBtn]="disableContinueBtn()"
                  [currentStep]="serviceRequestStepType.Confirmation"
                  [equipmentList]="basket.tools"
                  (continue)="continueStepper($event)"
                  (stepperClose)="closeStepper()"
                  class="fixed-stepper-control">
                </app-service-request-stepper-control>
              </div>
            </div>
          </mat-step>
        </mat-stepper>
      </div>
    </div>
  </mat-sidenav>
</mat-sidenav-container>
